export default {
  // hostname: "http://localhost:5004",
  hostname: "https://test2.e-attendance.com",
};
